function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

const AccessContext = require('./contexts/access-context');

function _call(body, then, direct) {
  if (direct) {
    return then ? then(body()) : body();
  }

  try {
    var result = Promise.resolve(body());
    return then ? result.then(then) : result;
  } catch (e) {
    return Promise.reject(e);
  }
}

const Pin = require('../entities/pin');
/*:: type offerIdType = offerId;*/


const serialize = (payload
/*: { pins: Array<Pin> }*/
) => ({
  pins: payload.pins.map(Pin.toJson)
});

const parse = Pin.fromJson;

class OfferCodesRepo {
  constructor(client
  /*: ApiClient*/
  , context
  /*: AccessContext*/
  , offerId
  /*: offerIdType*/
  ) {
    this.client = client;
    this.context = context;
    this.offerId = offerId;
  }

  getPins()
  /*: Promise<{ pins: Array<Pin> }>*/
  {
    const _this = this;

    return _call(function () {
      const offerId = _this.offerId;

      const {
        propertyId,
        businessId
      } = _this.context.serialize();

      const path = `/properties/${propertyId}/businesses/${businessId}/offers/${offerId}/pins`;
      const req = new _this.client.Request(path, {});
      req.parse = parse;
      return _await(_this.client.get(req), function (pagedList) {
        return {
          pins: pagedList.items
        };
      });
    });
  }

  setPins(newPins
  /*: Array<Pin>*/
  )
  /*: Promise<any>*/
  {
    const offerId = this.offerId;
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const path = `/properties/${propertyId}/businesses/${businessId}/offers/${offerId}/pins`;
    const req = new this.client.Request(path, {
      pins: newPins
    });
    req.serialize = serialize;
    return this.client.post(req);
  }

}

module.exports = OfferCodesRepo;